import { useGetPaymentMethods } from "app/hooks";
import { useOrderContext } from "app/providers/OrderProvider";
import PaymentHeader, { PaymentHeaderTypes } from "entities/payment-header";
import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { useEffect, useState } from "react";
import { PaymentType, paymentTypesCustom } from "shared/utils/payment";
import CustomLink from "shared/ui/typography/CustomLink";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";
import PaymentWarranty from "widgets/payment-warranty";
import { useSearchParams } from "react-router-dom";
import PaymentClientService from "entities/payment-client-service";

const CustomPayment = () => {
  const {
    getPaymentTypeList,
    customAmount,
    paymentAction,
    setPaymentAction,
    setBank,
    setPaymentMethod,
  } = usePaymentContext();
  const { paymentMethods } = useGetPaymentMethods();
  const { order, warrantyPackage } = useOrderContext();

  const [paymentTypesList, setPaymentTypesList] = useState<PaymentType[]>([]);
  const [searchParams] = useSearchParams();
  const standardOrderID = searchParams.get("pOrderId");

  useEffect(() => {
    if (paymentMethods) {
      setPaymentTypesList(getPaymentTypeList(paymentTypesCustom));
    }
  }, [paymentMethods]);

  return (
    <div
      className={`gg-col-span-12 gg-mb-16 sm:gg-col-span-11 lg:gg-col-span-9 xl:gg-col-span-6 xl:gg-mb-0 xl:gg-pr-12`}
    >
      {standardOrderID ? (
        <PaymentHeader
          type={PaymentHeaderTypes.ALL_PAYMENTS}
          className="gg-mb-2"
        />
      ) : (
        <PaymentHeader
          type={PaymentHeaderTypes.CUSTOM_PAYMENT}
          className="gg-mb-2"
        />
      )}

      {!standardOrderID && (
        <Text className="gg-mb-10">
          Heb je toch nog vragen of een opmerking? Stuur ons een e-mail naar{" "}
          <CustomLink to="mailto:info@gewoongers.nl">
            info@gewoongers.nl
          </CustomLink>{" "}
          dan nemen we zo snel mogelijk contact met je op.
        </Text>
      )}

      <div className={standardOrderID ? "gg-mb-10 gg-mt-3" : ""}>
        {order ? (
          <Text>
            Openstaand bedrag:{" "}
            <span className="gg-font-bold">
              {getFormattedPrice(
                order.paymentData.total -
                  order.paymentData.paid +
                  (warrantyPackage && !order.warrantyPackage
                    ? warrantyPackage?.price
                    : 0),
              )}
            </span>
          </Text>
        ) : (
          <></>
        )}

        <Text>
          Te betalen bedrag:{" "}
          <span
            className={
              standardOrderID ? "gg-text-lg gg-font-bold" : "gg-font-bold"
            }
          >
            {getFormattedPrice(customAmount)}
          </span>
        </Text>
      </div>

      {!standardOrderID && <PaymentWarranty className="gg-mt-5" />}
      <PaymentMethods
        method={PaymentMethod.CUSTOM_PAYMENT}
        types={paymentTypesList}
        paymentAction={paymentAction}
        setPaymentAction={setPaymentAction}
      />
      {standardOrderID && <PaymentClientService />}
    </div>
  );
};
export default CustomPayment;
